<template>
  <template v-if="user && [304, 566, 5814].includes(user.id)">
    <slot />
  </template>
</template>

<script setup lang="ts">
const user = useUser()
</script>
